<script>
export default {
  name: "PortalButtonLink",

  props: {
    color: { required: false, type: String, default: "primary" },
    href: { required: true, type: String },
    target: { required: false, type: String, default: "" },
  },

  emits: ["click"],
}
</script>

<template>
  <a
    :href="href"
    :target="target"
    :class="[
      color === 'primary'
        ? 'text-white border-primary-500 hover:border-primary-600 bg-primary-500 hover:bg-primary-600 focus:ring-primary-300'
        : '',
      color === 'primary-bordered'
        ? 'text-primary-600 border-primary-600 hover:border-primary-600 bg-white hover:bg-gray-50 focus:ring-primary-300'
        : '',
      color === 'primary-bordered-transparent'
        ? 'text-primary-600 border-primary-600 hover:border-primary-600 bg-transparent hover:bg-gray-50 focus:ring-primary-300'
        : '',
      color === 'primary-text'
        ? '!font-bold text-primary-600 hover:text-primary-700 focus:ring-primary-300 border-none'
        : '',
      color === 'red'
        ? 'text-white border-red-500 hover:border-red-600 bg-red-500 hover:bg-red-600 focus:ring-red-300'
        : '',
      color === 'white' ? 'text-gray-700 hover:bg-gray-100 focus:ring-primary-300' : '',
      color === 'gray'
        ? 'text-gray-500 font-bold border-gray-300 hover:bg-gray-100 focus:ring-primary-300 !px-3 !py-2'
        : '',
      color === 'gray-no-border'
        ? 'text-gray-500 border-none font-bold hover:bg-gray-100 focus:ring-primary-300 !px-3 !py-2'
        : '',
      color === 'green-text'
        ? '!font-bold text-green-600 hover:bg-green-100 hover:text-green-700 focus:ring-primary-300 border-none'
        : '',
      $attrs.disabled ? 'cursor-not-allowed !bg-green-400 hover:bg-green-400 !border-primary-400' : '',
    ]"
    class="flex items-center focus:ring-4 border font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </a>
</template>

<style scoped></style>
